import React from 'react';
import HeaderOne from "./header/HeaderOne";
import CustomFooter from '../elements/CustomFooter/CustomFooter';

const Layout = ({children}) => {
    return (
        <>
            <main className="page-wrapper">
                <HeaderOne btnStyle="btn-small round btn-icon" HeaderSTyle="header-not-transparent" />
                {children}
                <CustomFooter />
            </main>
        </>
    )
}
export default Layout;
